import { BiUserPlus } from "react-icons/bi";
import "./styles.css";
import AddSiteImg from "../../../assets/svg/siteimg.svg";
import { useEffect, useState } from "react";
import "antd/dist/antd.css";

import { Button } from "../../Button";
import axios from "../../../utils/axios";
import toast from "react-hot-toast";
import { Select } from "antd";

const { Option } = Select;
const SetMinimumVending = ({ zones, closeModal }) => {
  const [zone, setZone] = useState(null);
  const [minimumvend, setMinimumvend] = useState("");
  const [loading, setLoading] = useState(false);

  const submitMinVend = () => {
    if (!zone) return toast.error("Please select a zone");
    if (!minimumvend)
      return toast.error("Please enter a value for minimum vend");
    if (isNaN(Number(minimumvend)))
      return toast.error("Minimum vend must be a number");
    setLoading(true);
    axios
      .post("/settings/setminimumvending", { zone, minimumvend })
      .then((response) => {
        toast.success("Minimum vend has been set");
        setLoading(false);
        closeModal();
      })
      .catch((err) => {
        setLoading(false);
        toast(err.message);
      });
  };

  return (
    <div className="backdrop">
      <div className="bg-white shadow-md rounded-md w-[95%] md:w-[450px] px-3 py-4 animate__animated animate__fadeInUp">
        <div className="flex items-center justify-between">
          <div className="font-semibold mb-1 "> Set minimun vending</div>
          <div
            className="text-secondary cursor-pointer"
            onClick={() => closeModal(false)}
          >
            Close
          </div>
        </div>

        <div className="mt-4">
          Fill in the fields below to set the minimun vending for a project site
        </div>
        <div className="input-entry w-100 mt-2">
          <div>Select project site</div>
          <Select
            style={{ width: "100%", fontSize: "1rem" }}
            allowClear
            size="large"
            placeholder="Select project site"
            value={zone}
            onChange={(val) => setZone(val)}
          >
            {zones.map((zone) => (
              <Option value={zone} key={zone}>
                {zone}
              </Option>
            ))}
          </Select>
        </div>
        <div className="input-entry w-full my-3">
          <div>Enter minimum vend value</div>
          <input
            type="text"
            className="w-full input-box px-2 rounded-1"
            placeholder={"Minimum vend."}
            onChange={(e) => setMinimumvend(e.target.value)}
            value={minimumvend}
          />
        </div>
        <div className="mt-3 w-full">
          <Button
            text="Done"
            height={"40px"}
            status={loading}
            onClick={() => submitMinVend()}
          />
        </div>
      </div>
    </div>
  );
};

export default SetMinimumVending;
